import React, { useState, useEffect, useRef } from 'react';
import create from './create.svg';
import './searchBarMenuItems.css';
import ContentSettingDropDown from './Part/ContentSettingDropDown';



function SearchBarMenuItems(props) {
	const [toggleSetting, setToggleSetting] = useState(false);
	//const [showModalTableOne, setShowModalTableOne] = useState(false);
	//const [closedDateRange, setClosedDateRange] = useState(false);
	const [officeBtnDropDown, setOfficeBtnDropDown] = useState(false);
	const [customerBtnDropDown, setCustomerBtnDropDown] = useState(false);
	const [customerDropDownMenu, setCustomerDropDownMenu] = useState(false);

	let settingMenuRef = useRef();
	let customerBtnRef = useRef();
	let OfficeBtnDropDownRef = useRef();
	useEffect(() => {
		function settingMenuAction() {
			let handler = (e) => {
				if (settingMenuRef.current !== null) {
					if (!settingMenuRef.current.contains(e.target)) {
						setToggleSetting(false);
					}
				}	

			};
			document.addEventListener("mousedown", handler);
			return () => { document.removeEventListener("mousedown", handler); }
		}
		
		function customerBtnAction() {
			let handleCustomereBnt = (e) => {
				//console.log(closedBtnRef.current)
				//console.log(closedBtnRef.current.contains(e.target))
				if(customerBtnRef.current !== null && customerBtnRef.current !== undefined){
					if(!customerBtnRef.current.contains(e.target)){
						//console.log(closedBtnRef.current)
						setCustomerBtnDropDown(() => false)
					}
				}
			}
			document.addEventListener("mousedown", handleCustomereBnt);
			return () => { document.removeEventListener("mousedown", handleCustomereBnt); }
		}
			
		function OfficeBtnAction() {
			let handleCloseBnt = (e) => {
				//console.log('current',OfficeBtnDropDownRef.current)
				//console.log('e',e.target)
				if(OfficeBtnDropDownRef.current !== null && OfficeBtnDropDownRef.current !== undefined){
					if(!OfficeBtnDropDownRef.current.contains(e.target)){
						//console.log(closedBtnRef.current)
						setOfficeBtnDropDown(() => false)
					}
				}
			}
			document.addEventListener("mousedown", handleCloseBnt);
			return () => { document.removeEventListener("mousedown", handleCloseBnt); }
		}
		settingMenuAction();
		customerBtnAction();
		OfficeBtnAction();
		
	},[]);
	//const closedUrl = "http://arobaniworks.com/api/support/orders?page=1&limit=80";
	/*
	const handleDateRange = () => {
		return (
			<div ref={closedBtnRef} style={{height:'auto',width:'18rem',left: '-185px', top: '45px', zIndex: '3' }} className="menuDropDown" >
				<div className="menuDropDown-header"><span onClick={() => setClosedDateRange(false)} style={{ position:'absolute',right:'6px',top:'2px',color: '#675dff', fontWeight: '900' }}>X</span></div>
				<div style={{overflow:'hidden',display:'flex',justifyContent:'space-around'}} className="menuDropDown-body">
					<div style={{display:'flex',flexDirection:'column'}}>
						<label style={{paddingBottom:'5px'}}>Start Date</label>
						<input style={{border:'0'}} type="date" defaultChecked='' />
					</div>
					<div style={{display:'flex',flexDirection:'column'}}>
					<label style={{paddingBottom:'5px'}}>End Date</label>
						<input style={{border:'0'}} type="date" defaultChecked='' />
					</div>
				</div>
				<div style={{paddingBottom:'20px'}} className="menuDropDown-footer"><button onClick={() => props.tableOneFetchOrders(30, 'id', ['status'], ['Closed'])} id="menuDropDown-footerbtn" >Apply</button></div>
			</div>
		)
	}
	*/	

	const orderDropDownBtn = () => {
		return (
			//onClick={setToggleSetting.bind(this, false)}
	
			<div onMouseLeave={() => setOfficeBtnDropDown(false)} ref={OfficeBtnDropDownRef} className="officeBtnDropDown" >
				<div  className="settingDropDown-body">
					<div onClick={() => { props.tableOneFetchOrders(30, 'id', ['status'], ['Created', 'Office', 'Vendor', 'Submitted', 'Packing', 'Pickup', 'Transit' ]); }} >
						<span className="material-symbols-outlined">delivery_truck_speed</span>
						<label htmlFor="c1-13">All Open</label>
					</div>
					<div onClick={() => { props.tableOneFetchOrders(30, 'id', ['status'], ['Transit'])}} >
						<span className="material-symbols-outlined">delivery_truck_speed</span>
						<label htmlFor="c1-13">In Transit</label>
					</div>
					<div onClick={() => { props.tableOneFetchOrders(30, 'id', ['status'], ['Pickup'])}}>
						<span className="material-symbols-outlined">Local_Shipping</span>
						<label htmlFor="c1-13">PickUp</label>
					</div>
					<div onClick={() => { props.tableOneFetchOrders(30, 'id', ['status'], ['Closed'])}}>
						<span className="material-symbols-outlined">List_Alt_Check</span>
						<label htmlFor="c1-13">Closed</label>
					</div>
					<hr />
					<div style={{justifyContent:'space-evenly',fontSize:'11px'}}>
						<div>
							<span className="material-symbols-outlined">Date_Range</span>
							<label htmlFor="c1-13">7 days</label>
						</div>
						<div>
							<span className="material-symbols-outlined">Date_Range</span>
							<label htmlFor="c1-13">2 Weeks</label>
						</div>
					</div>
					<div style={{justifyContent:'space-evenly',fontSize:'11px'}}>
						<div>
							<span className="material-symbols-outlined">Date_Range</span>
							<label htmlFor="c1-13">3 Weeks</label>
						</div>
						<div>
							<span className="material-symbols-outlined">Date_Range</span>
							<label htmlFor="c1-13">1 Month</label>
						</div>
					</div>
					<hr />
					{/* <div>
						<label className="settingDropDownName">Sumanto Biswas<br/>Developer</label>
					</div>        */}
				</div>
				
				
			</div>
		)
	}
	
	const customerDropDownBtn = () => {
		return (
			//onClick={setToggleSetting.bind(this, false)}
	
			<div onMouseOut={() => setCustomerBtnDropDown(false)} ref={customerBtnRef} className="customerBtnDropDown" >
				<div  className="settingDropDown-body">
					<div onClick={() => { props.tableOneFetchOrders(30, 'id', ['status'], ['Transit'])}} >
						<span className="material-symbols-outlined">Edit_Note</span>
						<label htmlFor="c1-13">Draft</label>
					</div>
					<div onClick={() => { props.tableOneFetchOrders(30, 'id', ['status'], ['Pickup'])}}>
						<span className="material-symbols-outlined">Lock_Reset</span>
						<label htmlFor="c1-13">Password Rest</label>
					</div>
					<div onClick={() => { props.tableOneFetchOrders(30, 'id', ['status'], ['Closed'])}}>
						<span className="material-symbols-outlined">Admin_Panel_Settings</span>
						<label htmlFor="c1-13">Aadhaar Verification</label>
					</div>
					<hr />
					
					{/* <div>
						<label className="settingDropDownName">Sumanto Biswas<br/>Developer</label>
					</div>        */}
				</div>
				
				
			</div>
		)
	}

	return (
		<div className="content-top-actionbar">
			<div className='logo-box' style={{ fontFamily: 'Sumo-React', fontWeight: '900', fontSize: '1.3rem', paddingRight: '1rem' }}>KalaCoat</div>
			<div className="search-bar">
				<span className="material-symbols-outlined search-icon">search</span>
				<input type="text" name="search" placeholder="Search.." onChange={({ target }) => { target.value.length > 3 && props.tableOneFetchOrders(30, 'id', ['status', 'customer_name', 'company_name', 'order_no', 'cust_order_no'], [target.value]); target.value.length == 0 && props.tableOneFetchOrders() }} />
				{/* <input type="text" name="search" placeholder="Search.." onChange={({target}) => {target.value.length>3 && props.tableOneRefresh('http://arobaniworks.com/api/support/orders?page=1&limit=30&search[]='+target.value); target.value.length===0 && props.tableOneRefresh() }}/> */}
			</div>
			<div className="content-menubar checkbox-wrapper-14">
				{/* <div className="menubar-developers-link" onClick={() => props.tableOneRefresh('http://arobaniworks.com/api/support/orders?page=1&limit=30&feild[]=status&search[]=pickup')}>Pick Up</div>
						<div className="menubar-developers-link" onClick={() => props.tableOneRefresh('http://arobaniworks.com/api/support/orders?page=1&limit=30&feild[]=status&search[]=transit')}>Transit</div>*/}
				{/* <div className="menubar-developers-link" onClick={() => props.tableOneRefresh( 10, 'id', ['status'], ['office','vendor'] )}>Close</div> */}


				{/*To Be deleted.  */}
				{/* <div ref={closedBtnRef} className="menubar-developers-link" onClick={() => { props.tableOneFetchOrders(30, 'id', ['status'], ['Closed']); setClosedDateRange(true) }}>Closed</div>
				{closedDateRange && handleDateRange()} */}

				{/*Customer Button will active in next phase not now.  */}
				{/* <div onMouseOver={() => setCustomerBtnDropDown(true)} style={{position:'relative',display:'inline-block'}} className="menubar-developers-link" onClick={() => { props.tableOneFetchOrders(30, 'id', ['status'], ['Created', 'Office', 'Vendor', 'Submitted', 'Packing', 'Pickup', 'Transit' ]); }}>
				<div>Customer</div>
				{customerBtnDropDown && customerDropDownBtn()}
				</div> */}
				

				<div style={{position:'relative'}} className="menubar-developers-link" onMouseOver={() => setOfficeBtnDropDown(true)} onClick={() => { props.tableOneFetchOrders(30, 'id', ['status'], ['Created', 'Office', 'Vendor', 'Submitted', 'Packing', 'Pickup', 'Transit' ]); }}>Orders</div> 
				{officeBtnDropDown && orderDropDownBtn()}
				<div className="menubar-developers-link" onClick={() => props.tableOneRefresh()}>Refresh</div>
				{/* 'http://arobaniworks.com/api/support/orders?page=1&limit=30&feild[]=status&search=created&search=office&search=vendor' */}

				{/*<div className="menubar-dark-mode">Dark mode<span className="material-symbols-outlined">toggle_off</span></div>*/}
				<div className="menubar-dark-mode">
					<label htmlFor="s1-14">Dark Mode</label>
					<input id="s1-14" type="checkbox" className="switch" />
				</div>

				<div className="menubar-help tooltip"><span className="material-symbols-outlined">contact_support</span><span className="tooltiptext">Help</span></div>
				<div className="menubar-notification tooltip"><span className="material-symbols-outlined">notifications_unread</span><span className="tooltiptext">Notification</span></div>

				<div className="menubar-setting tooltip" ref={settingMenuRef}>
					{
						<span className="material-symbols-outlined" onClick={(e) => { setToggleSetting(!toggleSetting); }} >settings</span>
					}
					<span className="tooltiptext">Setting</span>

					{toggleSetting && <ContentSettingDropDown updateIsLoggedIn={props.updateIsLoggedIn} />}

				</div>



				<div className="menubar-create tooltip" onClick={(e) => { props.showHideModal(true); }} ><img src={create} alt="create" /><span className="tooltiptext">Create</span>	</div>
			</div>
		</div>
	)
}

export default SearchBarMenuItems;